/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { appStorageController } from '@/app/storage';
import { rtkApi } from '@/z-shared/api';

interface SubscribeToNotificationsMutation {
    token: string;
}

interface UpdateSubscriptionTokenMutation extends SubscribeToNotificationsMutation {
    subscriptionId: string;
}

interface SubscribeResponse {
    id: string;
    userAgent: string;
    createdAt: string;
}

const notificationsApi = rtkApi.injectEndpoints({
    endpoints: build => ({
        subscribeToNotifications: build.mutation<SubscribeResponse, SubscribeToNotificationsMutation>({
            query: arg => ({
                url: '/notifications/subscriptions',
                body: arg,
                method: 'POST',
            }),
            invalidatesTags: [ 'subscriptionStatus' ],
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {
                    appStorageController.set('subscriptionId', res.data.id);
                    appStorageController.set('firebaseTokenLastUpdate', Date.now());
                });
            },
        }),
        updateSubscriptionToken: build.mutation<SubscribeResponse, UpdateSubscriptionTokenMutation>({
            query: ({ token, subscriptionId }) => ({
                url: `/notifications/subscriptions/${subscriptionId}`,
                body: { token },
                method: 'PATCH',
            }),
            invalidatesTags: [ 'subscriptionStatus' ],
            async onQueryStarted(_, { queryFulfilled }) {
                queryFulfilled.then(res => {
                    appStorageController.set('subscriptionId', res.data.id);
                    appStorageController.set('firebaseTokenLastUpdate', Date.now());
                });
            },
        }),
        unsubscribeFromNotifications: build.mutation<void, string>({
            query: arg => ({
                url: `/notifications/subscriptions/${arg}`,
                method: 'DELETE',
            }),
            invalidatesTags: [ 'subscriptionStatus' ],
        }),
        getSubscriptionsStatus: build.query<SubscribeResponse, string>({
            query: arg => ({
                url: `/notifications/subscriptions/${arg}`,
                method: 'GET',
            }),
            providesTags: [ 'subscriptionStatus' ],
        }),
        getAllSubscriptions: build.query<SubscribeResponse[], void>({
            query: () => ({
                url: '/notifications/subscriptions',
                method: 'GET',
            }),
        }),
    }),
});

export const useSubscribeToNotifications = notificationsApi.useSubscribeToNotificationsMutation;
export const useUnsubscribeFromNotifications = notificationsApi.useUnsubscribeFromNotificationsMutation;
export const useUpdateSubscriptionToken = notificationsApi.useUpdateSubscriptionTokenMutation;
export const useGetSubscriptionsStatus = notificationsApi.useGetSubscriptionsStatusQuery;
export const useGetAllSubscriptions = notificationsApi.useGetAllSubscriptionsQuery;
